<div class="d-flex flex-column h-100" *ngIf="sku">
  <div class="price-info">
    <div class="price-info_row price-info_firstRow" [ngClass]="{'price-info_column' : isSidePanel}">
      <div class="price-info_box" *ngFor="let price of sku?.priceBreakdown" >
        <div class="price-info_box--header">
          <span class="label"> {{ price.name }} {{ price.name === "Markup" ? "(" + (price.value | percent) + ")" : "" }}
            <i *ngIf="price.tooltip!=''"
            matTooltip="{{price.tooltip}}" class="fas fa-info-circle ms-1"></i>
            <span class="status status-{{selectedMarkupType[0]?.value === 1 ? 'Markup' : selectedMarkupType[0]?.value === 2 ? 'Margin' : 'Amount'}}" [ngClass]="{'badge-position' : !(price?.configType === 'Auto' && (price.name === 'Markup' || price.name === 'Min Price'))}"
             *ngIf="price.name === 'Markup'">{{selectedMarkupType[0]?.value === 1 ? 'Markup' : selectedMarkupType[0]?.value === 2 ? 'Margin' : 'Amount'}}</span></span>
          <span class="pricing-label">{{
            price.name === "Markup"
              ? (markupAmount | currency)
              : (price.value | currency)
          }} <span class="title-badge" [ngClass]="{'badge-position' : price.name !== 'Markup'}" *ngIf="price?.configType === 'Auto' && (price.name === 'Markup' || price.name === 'Min Price')">Auto</span></span>
        </div>
        <span class="price-info_box--warning" *ngIf="price?.configType === 'Auto' &&  price.name === 'Min Price'">Last Updated : Yesterday 2 PM</span>
      </div>
    </div>
  </div>
  <app-price-breakdown [selectedRow]="sku"></app-price-breakdown> 
  <div class="footer" [ngClass]="{'footer-fixed' : isSidePanel}">
    <app-button (click)="edit()">Set Pricing</app-button>
    <app-button (click)="calculate()">Calculate Pricing</app-button>
  </div>
</div>

<div class="loader" *ngIf="!sku">
  <img  src="assets/images/nineyard-loading.gif" >
</div>